import { type Prize } from '../types';

export const getMaxPrizeValue = (prizes: ReadonlyArray<Prize>) => {
    if (!prizes.length) {
        return 0;
    }

    return prizes[prizes.length - 1].value;
};
